import React, { useState, useRef } from 'react';
import {
    createStyles,
    makeStyles,
    Theme,
} from '@material-ui/core';
import {
    List,
    ListCell,
    ListContainer,
    ListHeader,
    ListItem,
} from '../../../components/List';
import { Detail } from '../../../data/Repair';
import { useWindowResizeEffect } from '../../../units/useWindowResizeEffect';

type DetailListProps = {
    detailList: Detail[],
    onItemClick?: (item: Detail) => void,
    listRef?: React.RefObject<HTMLDivElement>,
    disableDeliveryDate?: boolean,
};

DetailList.defaultProps = {
    onItemClick: () => {},
    listRef: null,
    disableDeliveryDate: false,
};

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        '& .MuiTableCell-stickyHeader': {
            backgroundColor: theme.palette.background.paper,
        },
    },
    container: {
        height: '100%',
    },
}));

function DetailList(props: DetailListProps): React.ReactElement {
    const {
        detailList,
        onItemClick = DetailList.defaultProps.onItemClick,
        listRef,
        disableDeliveryDate,
    } = props;
    const classes = useStyles();

    const rootEl = useRef<HTMLDivElement>(null);
    const [containerHeight, setContainerHeight] = useState('100%');

    useWindowResizeEffect(() => {
        if (rootEl && rootEl.current) {
            // setContainerHeight(`${rootEl.current.clientHeight - 56}px`);
        }
    }, [rootEl]);

    return (
        <div className={classes.root}>
            <ListContainer className={classes.container} containerRef={rootEl}>
                <ListHeader>
                    <ListCell width={disableDeliveryDate ? 200 : 160}>品名</ListCell>
                    <ListCell width={80}>單位</ListCell>
                    <ListCell width={80} align="right">數量</ListCell>
                    {!disableDeliveryDate ? (
                        <ListCell width={120}>交期(天)</ListCell>
                    ) : null}
                </ListHeader>
                <List containerHeight={containerHeight} containerRef={listRef}>
                    {detailList.map((item) => (
                        <ListItem onClick={() => onItemClick(item)}>
                            <ListCell width={disableDeliveryDate ? 200 : 160}>{item.product_id}</ListCell>
                            <ListCell width={80}>{item.product_uom}</ListCell>
                            <ListCell width={80} align="right">{item.product_uom_qty}</ListCell>
                            {!disableDeliveryDate ? (
                                <ListCell width={120}>{item.delivery_date}</ListCell>
                            ) : null}
                        </ListItem>
                    ))}
                </List>
            </ListContainer>
        </div>
    );
}

export { DetailList };
